import type { RouteRecordRaw } from "vue-router";

const Stamp = () => import("./view/StampView.vue");
const UserShift = () => import("./view/UserShift.vue");
const UserShiftOverview = () => import("./view/UserShiftOverview.vue");
const YearlyStampOverview = () => import("./view/YearlyStampOverview.vue");
const StampUserList = () => import("./view/StampUserList.vue");
const UserShiftTeamPlanningOverview = () => import("./view/UserShiftTeamPlanningOverview.vue");
const Vacations = () => import("./view/VacationsOverview.vue");
const SiteConfigs = () => import("./view/SiteConfigsOverview.vue");
const CreateSiteConfig = () => import("./view/CreateSiteConfigView.vue");
const UpdateSiteConfig = () => import("./view/UpdateSiteConfigView.vue");
const UserListVacationConfig = () => import("./view/UserListVacationConfig.vue");
const TimeStampOverviewSubmittedSheets = () =>
  import("./view/TimeStampOverviewSubmittedSheets.vue");

const router: RouteRecordRaw[] = [
  {
    path: "/stamp/internal",
    name: "loggedInStamp",
    component: Stamp,
  },
  {
    path: "/stamp",
    name: "stamp",
    component: Stamp,
    meta: {
      hideNavbar: true,
      backgroundImage: true,
      noAuthNeeded: true,
      notSaveLastPage: true,
      supportsMonitorView: true,
    },
  },
  {
    path: "/stamp/stampOverview/userList",
    name: "StampUserList",
    component: StampUserList,
    meta: {
      rights: ["timestampclock.admin"],
    },
  },
  {
    path: "/stamp/stampOverview/yearly",
    name: "YearlyStampOverview",
    component: YearlyStampOverview,
    meta: {
      rights: ["timestampclock.admin"],
    },
  },
  {
    path: "/stamp/stampOverview/self",
    name: "StampOverviewSelf",
    component: () => import("./view/TCMonthlyStampOverview.vue"),
    props: (route) => {
      return {
        selectedDate: route.query.date,
      };
    },
  },
  {
    path: "/stamp/stampOverview/daily",
    name: "StampOverviewDaily",
    component: () => import("./view/TCDailyStampOverview.vue"),
    meta: {
      rights: ["timestampclock.admin"],
    },
  },
  {
    path: "/stamp/stampOverview/:id",
    name: "StampOverview",
    component: () => import("./view/TCMonthlyStampOverview.vue"),
    props: (route) => {
      return {
        userIdProp: parseInt(route.params.id.toString(), 10),
        selectedDate: route.query.date,
      };
    },
    meta: {
      rights: ["timestampclock.admin"],
      authorizationSiteResource: "user",
    },
  },
  {
    path: "/stamp/userShift/:siteId/:id?",
    name: "UserShift",
    component: UserShift,
    meta: {
      rights: ["timestampclock.admin"],
      authorizationSiteResource: "userShiftSchedule",
      authorizationSiteResourceOptional: true,
    },
    props: (route) => {
      return {
        id: route.params.id ? Number(route.params.id.toString()) : undefined,
        siteId: Number(route.params.siteId.toString()),
      };
    },
  },
  {
    path: "/stamp/userShiftOverview",
    name: "UserShiftOverview",
    component: UserShiftOverview,
    meta: {
      rights: ["timestampclock.admin"],
    },
  },
  {
    path: "/stamp/userShiftAssociations",
    name: "UserShiftTeamPlanningOverview",
    component: UserShiftTeamPlanningOverview,
    meta: {
      rights: ["timestampclock.admin"],
    },
  },
  {
    path: "/stamp/vacationOverview/:view",
    name: "Vacations",
    component: Vacations,
    props: (route) => ({
      userView: route.params.view === "self",
    }),
  },
  {
    path: "/stamp/submittedSheetsOverview",
    name: "timeStampOverviewSubmittedSheets",
    component: TimeStampOverviewSubmittedSheets,
    meta: {
      rights: ["timestampclock.admin"],
    },
  },
  {
    path: "/stamp/siteConfigs",
    name: "SiteConfigs",
    component: SiteConfigs,
    meta: {
      rights: ["timestampclock.admin"],
    },
  },
  {
    path: "/stamp/siteConfig",
    name: "CreateSiteConfig",
    component: CreateSiteConfig,
    meta: {
      rights: ["timestampclock.admin"],
    },
  },
  {
    path: "/stamp/siteConfig/:id",
    name: "UpdateSiteConfig",
    component: UpdateSiteConfig,
    meta: {
      rights: ["timestampclock.admin"],
      authorizationSiteResource: "tcSiteConfig",
    },
    props: (route) => {
      return {
        id: Number(route.params.id.toString()),
      };
    },
  },
  {
    path: "/stamp/userListVacationConfig",
    name: "UserVacationConfig",
    component: UserListVacationConfig,
    meta: {
      rights: ["timestampclock.admin"],
    },
  },
  {
    path: "/stamp/userVacationConfig/:id",
    name: "TCUserManagement",
    component: () => import("./view/UserVacationConfig.vue"),
    props: (route) => ({
      userId: Number(route.params.id),
    }),
    meta: {
      rights: ["timestampclock.admin"],
      authorizationSiteResource: "user",
    },
  },
  {
    path: "/tc/teamPlanner/site",
    name: "TCTeamPlanner",
    component: () => import("./view/TCTeamPlanner.vue"),
    meta: {
      rights: ["timestampclock.admin"],
    },
  },
  {
    path: "/stamp/vacationPlanner/:id",
    name: "timeStampVacationPlannerUser",
    component: () => import("./view/VacationPlanner.vue"),
    props: (route) => ({
      userId: Number(route.params.id),
      date: route.query.date,
    }),
  },
  {
    path: "/stamp/attendanceList",
    name: "timeStampAttendanceList",
    component: () => import("./view/AttendanceList.vue"),
    meta: {
      rights: ["timestampclock.attendance"],
    },
  },
  {
    path: "/stamp/siteStampChangeRequest",
    name: "siteStampChangeRequest",
    component: () => import("./view/StampChangeRequestList.vue"),
    meta: {
      rights: ["timestampclock.admin"],
    },
  },
  {
    path: "/stamp/tcBlockedStampTry",
    name: "tcBlockedStampTry",
    component: () => import("./view/TCBlockedStampTry.vue"),
    meta: {
      rights: ["timestampclock.admin"],
    },
  },
];

export default router;
